"use strict";

require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/web.timers.js");
require("whatwg-fetch");
var _validation = _interopRequireDefault(require("./exceptions/validation"));
var _unauthorized = _interopRequireDefault(require("./exceptions/unauthorized"));
var _forbidden = _interopRequireDefault(require("./exceptions/forbidden"));
var _unavailable = _interopRequireDefault(require("./exceptions/unavailable"));
var _notFound = _interopRequireDefault(require("./exceptions/notFound"));
var _requestTimeout = _interopRequireDefault(require("./exceptions/requestTimeout/requestTimeout"));
var _authTokenExpired = _interopRequireDefault(require("./exceptions/authTokenExpired"));
var _keysToSnakeCase = _interopRequireDefault(require("res-extensions/build/keysToSnakeCase"));
var _keysToCamelCase = _interopRequireDefault(require("res-extensions/build/keysToCamelCase"));
var _objectToQueryString = _interopRequireDefault(require("res-extensions/build/objectToQueryString"));
var _config = _interopRequireDefault(require("./config"));
var _excluded = ["status"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Returns true for errors that represent transient failures and are safe to retry.
 * - TypeError: network-level failures (DNS, connection refused, fetch itself throws)
 * - UnavailableException: HTTP 500/502/503/504 and 408 (mapped by the switch statement)
 *
 * Non-retryable errors (401, 403, 404, 422 and their named exceptions) return false.
 */
var isRetryableError = function isRetryableError(error) {
  if (error instanceof TypeError) return true;
  if ((error === null || error === void 0 ? void 0 : error.name) === 'UnavailableException') return true;
  return false;
};
var _default = exports["default"] = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$fetcher = _ref.fetcher,
    fetcher = _ref$fetcher === void 0 ? window.fetch : _ref$fetcher,
    _ref$apiUrl = _ref.apiUrl,
    apiUrl = _ref$apiUrl === void 0 ? _config["default"].apiUrl : _ref$apiUrl,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'GET' : _ref$method,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? {} : _ref$headers,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$maxRetries = _ref.maxRetries,
    maxRetries = _ref$maxRetries === void 0 ? 0 : _ref$maxRetries,
    _ref$retryDelay = _ref.retryDelay,
    retryDelay = _ref$retryDelay === void 0 ? 1000 : _ref$retryDelay,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _config["default"].onError : _ref$onError;
  data = (0, _keysToSnakeCase["default"])(data);
  headers = _objectSpread(_objectSpread({}, _config["default"].headers), headers);
  var body;
  var queryString = '';
  if (Object.keys(data).length !== 0) {
    if (['GET', 'DELETE'].indexOf(method) > -1) queryString += '?' + (0, _objectToQueryString["default"])(data);else
      // POST or PUT
      body = JSON.stringify(data);
  }
  var _attempt = function attempt(retriesLeft) {
    var canReplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var fetchResponse = null;

    // CD-8740: `credentials: 'include'` makes the browser attach (and accept)
    // the HttpOnly `access_token` / `access_refresh` cookies on cross-origin
    // requests to the API host. Without it the browser default (`same-origin`)
    // applies and every request from this client is anonymous.
    return fetcher("".concat(apiUrl).concat(url).concat(queryString), {
      method: method,
      headers: headers,
      body: body,
      credentials: 'include'
    }).then(function (response) {
      fetchResponse = response;
      // Bodyless responses (204 No Content, or 205 Reset Content) have
      // nothing to parse — calling .json() on them throws
      // "Unexpected end of JSON input". Short-circuit so the catch below
      // doesn't fire and log a misleading parse error for a successful
      // request (e.g. a DELETE that returns 204).
      if (response.status === 204 || response.status === 205 || response.ok && response.headers.get("content-length") === "0") {
        return {
          status: response.status
        };
      }
      return response.json().then(function (body) {
        if (!(body !== null && body !== void 0 && body.status)) {
          return _objectSpread({
            status: response.status
          }, body);
        }
        return body;
      })["catch"](function (error) {
        console.error("Error when fetching from ".concat(apiUrl).concat(url).concat(queryString), error);
        return {
          status: response.status
        };
      });
    }).then(function (response) {
      return (0, _keysToCamelCase["default"])(response);
    }).then(function (response) {
      var _data$additionalInfo;
      var status = response.status,
        data = _objectWithoutProperties(response, _excluded);
      switch (true) {
        case status === undefined:
          return Promise.reject(response);
        case status >= 200 && status < 300:
          return Promise.resolve(data);
        case status === 401:
          if ((data === null || data === void 0 ? void 0 : data.message) === 'JWT::ExpiredSignature') return Promise.reject(new _authTokenExpired["default"](data));else return Promise.reject(new _unauthorized["default"](data));
        case status === 403:
          return Promise.reject(new _forbidden["default"](data));
        case status === 404:
          return Promise.reject(new _notFound["default"](data));
        case status === 408:
          return (0, _requestTimeout["default"])(response);
        case status === 422:
          return Promise.reject(new _validation["default"]((_data$additionalInfo = data === null || data === void 0 ? void 0 : data.additionalInfo) !== null && _data$additionalInfo !== void 0 ? _data$additionalInfo : data === null || data === void 0 ? void 0 : data.errors, data === null || data === void 0 ? void 0 : data.moreThanWeeks));
        default:
          return Promise.reject(new _unavailable["default"](data));
      }
    })["catch"](function (error) {
      var _fetchResponse;
      if (retriesLeft > 0 && isRetryableError(error)) {
        return new Promise(function (resolve) {
          return setTimeout(resolve, retryDelay);
        }).then(function () {
          return _attempt(retriesLeft - 1, canReplay);
        });
      }
      var context = {
        requestUrl: url,
        requestMethod: method,
        responseStatus: (_fetchResponse = fetchResponse) === null || _fetchResponse === void 0 ? void 0 : _fetchResponse.status,
        retriesAttempted: maxRetries - retriesLeft,
        tags: "api, fetch, ".concat(method, ", ").concat(error === null || error === void 0 ? void 0 : error.name)
      };
      return onError(error, context, canReplay ? function () {
        return _attempt(0, false);
      } : undefined);
    });
  };
  return _attempt(maxRetries);
};